/**
 * Calculate total quantity and total amount based on the given products data.
 *
 * @param productsData An array of products data containing information about price and quantity.
 * @returns An object containing the total quantity and total amount.
 */
export const calculateTotals = (productsData: ICartProduct[]) => {
  // Calculate total items based on quantity
  const totalQuantity = productsData.reduce(
    (total, item) => total + item.quantity,
    0
  );

  // Calculate total amount base on quantity and price
  const totalAmount = productsData.reduce(
    (total, item) => total + item.price,
    0
  );
  const roundedTotal = Math.round(totalAmount * 100) / 100;

  return { totalQuantity, totalAmount: roundedTotal };
};
